<template>
	<UserMenuBtn
		v-if="!loading"
		:full-name="formattedUser"
		:hide-logout-btn="!isAuthenticated"
		@logout="logout()"
	>
		<VListItem
			v-if="!isAuthenticated"
			exact
			@click="login(RolesEnum.ASSURE)"
		>
			<VListItemTitle>Salarié</VListItemTitle>
		</VListItem>
		<VListItem
			v-if="!isAuthenticated"
			exact
			@click="login(RolesEnum.EMPLOYEUR)"
		>
			<VListItemTitle>Employeur particulier</VListItemTitle>
		</VListItem>
		<template v-if="isAuthenticated">
			<VListItem
				v-for="(item, index) in links"
				:key="index"
				:disabled="item.disabled"
				:to="item.to ? item.to : null"
				exact
			>
				<VListItemTitle>{{ item.title }}</VListItemTitle>
			</VListItem>
		</template>
	</UserMenuBtn>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { RawLocation } from 'vue-router';
	import { mapActions, mapState } from 'vuex';
	import { RolesEnum } from '@/types/enum/RolesEnum';
	import RouteService from '@/services/RouteService';

	interface LinkItem {
		title: string;
		disabled: boolean;
		to?: RawLocation;
	}

	@Component({
		computed: mapState('auth', ['user', 'isAuthenticated', 'loading']),
		methods: mapActions('auth', [
			'logout'
		])
	})
	export default class HeaderMenu extends Vue {
		RolesEnum = RolesEnum;

		get formattedUser(): string {
			if (!this.isAuthenticated) {
				return 'Connexion';
			}

			const user = this.$store.state.auth.user;

			if (user.roles.includes('ROLE_TEMOIN')) {
				return `${this.user?.nom} ${this.user?.prenom} - ${this.role}`;
			}

			return user ? `${user.email} - ${this.role}` : '';
		}

		get role(): string {
			const user = this.$store.state.auth.user;

			if (user?.roles.includes('ROLE_ASSURE')) {
				return 'Salarié';
			}

			if (user?.roles.includes('ROLE_EMPLOYEUR')) {
				return 'Employeur';
			}

			if (user?.roles.includes('ROLE_TEMOIN')) {
				return 'Témoin';
			}

			return '';
		}

		get links(): LinkItem[] {
			return this.$t('components.layout.headerMenu.links') as unknown as LinkItem[];
		}

		login(userType: RolesEnum): void {
			RouteService.navigateToLoginPage(userType);
		}
	}
</script>
